import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import Document from "./Document";
import DocumentMerge from "./DocumentMerge";
import { NavLink } from 'react-router-dom';
import ImportExcel from "../ImportExcel";
import DatePicker from 'react-datepicker2';
import SelectAsync from 'react-select/async';
import Conflicts from "../Conflicts/Conflicts";

export default class Documents extends Base {
    constructor(props) {
        super(props);
        this.state = {
            isTemplate: (this.isNull(props.IsTemplate) ? false : props.IsTemplate),
            isReference: (this.isNull(props.IsReference) ? false : props.IsReference),
            controllerName: 'document',
            data: null,
            loading: true,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            ids: [],
            systemModuleId: 8,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 0,
            currentConflictId: null,
            conflicts: []
        };
        this.state.filters = {
            status: 0,
            filter: 0,
            type: this.getDefaultGuid(),
            typeName: '',
            isTemplate: this.state.isTemplate,
            isReference: this.state.isReference,
            sortBy: 0,
            fromNumber: '',
            toNumber: '',
            fromPrice: '',
            toPrice: '',
            fromDate: '',
            toDate: '',
            fromDateConverted: '',
            toDateConverted: '',
            orderingId: this.isNull(props.OrderingId) ? null : props.OrderingId,
            currentAnnual: this.isNull(props.CurrentAnnual) ? true : props.CurrentAnnual,
        }
        this.setMenuId(this.state.isReference);
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    setMenuId(isReference) {
        if (isReference) this.state.menuId = 40;
        if (!isReference) this.state.menuId = 39;
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentWillReceiveProps(props) {
        if (props.IsTemplate === this.state.filters.isTemplate && props.IsReference === this.state.filters.isReference) return;
        this.state.isTemplate = props.IsTemplate;
        this.state.isReference = props.IsReference;
        this.setMenuId(this.state.isReference);

        this.state.filters.isTemplate = props.IsTemplate;
        this.state.filters.isReference = props.IsReference;
        this.refreshData();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
                this.getConflicts();
            });
    }
    getConflicts() {
        this.httpPost("api/v1/conflict/list", {
            filters: {
                usage: 4
            }
        })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ conflicts: data.records });
                }
            });
    }
    showConflicts() {
        this.showComponents({ component: <Conflicts Caller={this} Usage={4} /> });
    }
    saveChecked(entityRecordId, checked) {
        if (this.isBlank(this.state.currentConflictId)) return;
        var conflictId = this.state.currentConflictId;

        this.httpPost("api/v1/conflict/check", {
            usage: 4,
            conflictId,
            entityRecordId,
            checked
        }, false)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });

        this.state.data.records.forEach(f => {
            if (f.id === entityRecordId) {
                var tempConflicts = [];
                f.conflicts.forEach(c => {
                    if (c !== conflictId) tempConflicts.push(c);
                });
                if (checked) tempConflicts.push(conflictId);
                f.conflicts = tempConflicts;
            }
        });

        this.setState({ data: this.state.data });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Document Caller={this} Id={id} IsTemplate={this.state.isTemplate} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Document OrderingId={this.state.filters.orderingId} Caller={this} IsTemplate={this.state.isTemplate} /> });
    }
    onMerge() {
        this.removeKeyDown();
        this.showComponents({
            component: <DocumentMerge Caller={this} Types={this.state.data.types} />
        });
    }
    onImport() {
        this.removeKeyDown();
        this.showComponents({ component: <ImportExcel Caller={this} Type={4} CompanyId={this.state.data.global.company.id} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        {this.state.inline === false && <div className="nk-block-head-content">
                            {!this.state.isTemplate ?
                                !this.state.isReference ?
                                    <h3 className="nk-block-title page-title">فهرست اسناد</h3>
                                    :
                                    <h3 className="nk-block-title page-title">فهرست اسناد مرجع</h3>
                                : <h3 className="nk-block-title page-title">فهرست الگوهای جدید</h3>}
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} مورد یافت شد</p>
                            </div>
                        </div>}
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        {!this.state.isReference && <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}>
                                                {!this.state.isTemplate ? <span>سند جدید</span>
                                                    : <span>الگوی جدید</span>}
                                            </a>
                                        </li>}
                                        {this.state.inline === false && !this.state.isTemplate && !this.state.isReference && <li>
                                            <a onClick={e => this.onMerge()} className="btn-sm hand btn btn-danger"><span>تشکیل اسناد مرجع</span></a>
                                        </li>}
                                        {this.state.inline === false && !this.state.isTemplate && !this.state.isReference && <li>
                                            <a onClick={e => this.onImport()} className="btn-sm hand btn btn-success"><span>ورود اکسل</span></a>
                                        </li>}
                                        {this.state.inline === false && !this.state.isTemplate && !this.state.isReference && <li>
                                            <a onClick={e => this.refreshData(e, "list", "excel")} className="btn-sm hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>}
                                        {this.state.inline === false && !this.state.isTemplate && !this.state.isReference && <li>
                                            <a onClick={e => this.exportFromUrl('excel', "api/v1/document/elist")} className="btn-sm hand btn btn-success"><span>دفتر الکترونیکی - روزانه</span></a>
                                        </li>}
                                        {this.state.inline === false && !this.state.isTemplate && !this.state.isReference && <li>
                                            <a onClick={e => this.exportFromUrl('excel', "api/v1/document/elist2")} className="btn-sm hand btn btn-success"><span>دفتر الکترونیکی - ماهانه</span></a>
                                        </li>}

                                        {this.state.inline === false && !this.state.isTemplate && !this.state.isReference && <li>
                                            <NavLink to="/documenttemplates/" className="btn-sm hand btn btn-warning"><span>الگوها</span></NavLink>
                                        </li>}
                                        {this.state.inline === false && !this.state.isTemplate && !this.state.isReference && <li>
                                            <NavLink to="/documenttypes/" className="btn-sm hand btn btn-warning"><span>انواع سندها</span></NavLink>
                                        </li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            {!this.state.isTemplate && <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="شرح سند" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.status} onChange={e => this.state.filters.status = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه اسناد</option>
                                                    <option value="1">اتوماتیک</option>
                                                    <option value="2">دستی</option>
                                                    <option value="3">تایید شده</option>
                                                    <option value="4">ذخیره موقت</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <SelectAsync
                                                    style={{ "width": "100%" }}
                                                    defaultValue={this.state.filters.type !== this.getDefaultGuid() ? [{ value: this.state.filters.type, label: this.state.filters.typeName }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب نوع سند"
                                                    noOptionsMessage={({ inputValue }) =>
                                                        inputValue ? "نتیجه‌ای یافت نشد" : null
                                                    }
                                                    defaultOptions={[]}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    loadOptions={(inputValue, callback) => this.loadConstantsOptions(inputValue, callback, 4)}
                                                    onChange={e => {
                                                        this.state.filters.type = e.value;
                                                        this.state.filters.typeName = e.label;
                                                    }}
                                                />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.sortBy} onChange={e => this.state.filters.sortBy = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">نمایش بر اساس تاریخ (نزولی)</option>
                                                    <option value="1">نمایش بر اساس تاریخ (صعودی)</option>
                                                    <option value="2">نمایش بر اساس شماره (نزولی)</option>
                                                    <option value="3">نمایش بر اساس شماره (صعودی)</option>
                                                    <option value="4">نمایش بر اساس مبلغ (نزولی)</option>
                                                    <option value="5">نمایش بر اساس مبلغ (صعودی)</option>
                                                    <option value="6">نمایش بر اساس شماره عطف (نزولی)</option>
                                                    <option value="7">نمایش بر اساس شماره عطف (صعودی)</option>
                                                    <option value="8">نمایش بر اساس شماره اختصاصی (نزولی)</option>
                                                    <option value="9">نمایش بر اساس شماره اختصاصی (صعودی)</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.filter} onChange={e => this.state.filters.filter = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">فاقد فیلتر</option>
                                                    <option value="1">آرتیکل های فاقد تفصیل با معین تفصیل پذیر</option>
                                                    <option value="2">کلیه آرتیکل های فاقد تفصیل</option>
                                                    <option value="3">فاقد شرح آرتیکل</option>
                                                    <option value="4">فاقد شرح سند</option>
                                                    <option value="5">اسناد با مبلغ صفر</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-inline flex-nowrap gx-3 mt-2">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.fromNumber} onChange={e => this.state.filters.fromNumber = e.target.value} placeholder="از شماره" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.toNumber} onChange={e => this.state.filters.toNumber = e.target.value} placeholder="تا شماره" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.fromPrice} onChange={e => this.state.filters.fromPrice = e.target.value} placeholder="از مبلغ" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.toPrice} onChange={e => this.state.filters.toPrice = e.target.value} placeholder="تا مبلغ" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"از تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => {
                                                        this.state.filters.fromDate = e;
                                                        this.state.filters.fromDateConverted = this.convertMomentToDb(e)
                                                    }}
                                                    value={this.getFormatedDateForDatePicker(this.state.filters.fromDate)}
                                                />
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"تا تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => {
                                                        this.state.filters.toDate = e;
                                                        this.state.filters.toDateConverted = this.convertMomentToDb(e)
                                                    }}
                                                    value={this.getFormatedDateForDatePicker(this.state.filters.toDate)}
                                                />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>}
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ موردی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            {this.state.isTemplate && <div className="nk-tb-col text-center"><span className="sub-text">عنوان</span></div>}
                                            {!this.state.isTemplate && <div className="nk-tb-col text-center"><span className="sub-text">شماره</span></div>}
                                            {!this.state.isTemplate && <div className="nk-tb-col text-center"><span className="sub-text">عطف</span></div>}
                                            {!this.state.isTemplate && <div className="nk-tb-col text-center"><span className="sub-text">فرعی</span></div>}
                                            {!this.state.isTemplate && <div className="nk-tb-col text-center"><span className="sub-text">اختصاصی</span></div>}
                                            {!this.state.isTemplate && <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">شرح</span></div>
                                            {!this.state.isTemplate && <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">مرحله</span></div>
                                            {this.state.filters.currentAnnual === false && <div className="nk-tb-col text-center"><span className="sub-text">سال مالی</span></div>}
                                            {!this.state.isTemplate && <div className="nk-tb-col text-center"><span className="sub-text">اتوماتیک</span></div>}
                                            {!this.state.isTemplate && <div className="nk-tb-col text-center"><span className="sub-text">سیستم</span></div>}
                                            {!this.state.isTemplate && <div className="nk-tb-col text-center"><span className="sub-text">مبلغ</span></div>}
                                            <div className="nk-tb-col text-end" style={{ display: "flex", gap: "5px", padding: "5px" }}>
                                                <select defaultValue={this.state.currentConflictId} onChange={e => this.setState({ currentConflictId: e.target.value })} className="form-control">
                                                    <option value="">انتخاب مغایرت</option>
                                                    {this.state.conflicts.map(con => <option value={con.id}>{con.name}</option>)}
                                                </select>
                                                <a onClick={e => this.showConflicts()} className="hand text-primary"><i className="fa fa-list"></i></a>
                                            </div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className={"nk-tb-item " + (record.conflicts.includes(this.state.currentConflictId) ? "highlighted" : "")} key={record.id + "_" + this.state.currentConflictId}>
                                                {this.state.isTemplate && <div className="nk-tb-col">
                                                    <span className="onlyMobile">عنوان: </span>
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                            {record.title}
                                                        </a>
                                                    </span>
                                                </div>}
                                                {!this.state.isTemplate && <div className="nk-tb-col">
                                                    <span className="onlyMobile">شماره: </span>
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                            {record.number}
                                                        </a>
                                                    </span>
                                                </div>}
                                                {!this.state.isTemplate && <div className="nk-tb-col">
                                                    <span className="onlyMobile">عطف: </span>
                                                    <span className="sub-text text-center">{record.number2}</span>
                                                </div>}
                                                {!this.state.isTemplate && <div className="nk-tb-col">
                                                    <span className="onlyMobile">فرعی: </span>
                                                    <span className="sub-text text-center">{record.subNumber}</span>
                                                </div>}
                                                {!this.state.isTemplate && <div className="nk-tb-col">
                                                    <span className="onlyMobile">اختصاصی: </span>
                                                    <span className="sub-text text-center">{record.typeNumber}</span>
                                                </div>}
                                                {!this.state.isTemplate && <div className="nk-tb-col">
                                                    <span className="onlyMobile">تاریخ: </span>
                                                    <span className="sub-text text-center">{record.dateString}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شرح: </span>
                                                    <span className="sub-text text-center">{record.description}</span>
                                                </div>
                                                {!this.state.isTemplate && <div className="nk-tb-col">
                                                    <span className="onlyMobile">وضعیت: </span>
                                                    <span className="sub-text text-center">{record.statusString}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">مرحله: </span>
                                                    <span className="sub-text text-center">{record.workFlowStepName}</span>
                                                </div>
                                                {this.state.filters.currentAnnual === false && <div className="nk-tb-col">
                                                    <span className="onlyMobile">سال مالی: </span>
                                                    <span className="sub-text text-center">{record.annualTitle}</span>
                                                </div>}
                                                {!this.state.isTemplate && <div className="nk-tb-col">
                                                    <span className="onlyMobile">اتوماتیک: </span>
                                                    <span className="sub-text text-center">{record.automatic ? "بله" : "خیر"}</span>
                                                </div>}
                                                {!this.state.isTemplate && <div className="nk-tb-col">
                                                    <span className="onlyMobile">سیستم: </span>
                                                    <span className="sub-text text-center">{record.sourceString}</span>
                                                </div>}
                                                {!this.state.isTemplate && <div className="nk-tb-col">
                                                    <span className="onlyMobile">مبلغ: </span>
                                                    <span className="sub-text text-center">{this.money(record.sumBed)}</span>
                                                </div>}
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    {!this.isBlank(this.state.currentConflictId) && <input type="checkbox" key={record.id + "_" + this.state.currentConflictId} defaultChecked={record.conflicts.includes(this.state.currentConflictId)} onChange={e => this.saveChecked(record.id, e.target.checked)} />}
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        <li>
                                                                            <a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                                                                                <em className="icon ni ni-cross-fill-c"></em> حذف
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline === false && <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),

                this.state.inline === false && <Footer />
            ];

        return contents;
    }
}